var React = require('react');

function HeadOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64 88C66.2091 88 68 86.2091 68 84V67.6472C77.7021 62.1836 84 51.8479 84 40C84 22.1909 69.8091 8 52 8C35.0255 8 21.6041 21.0678 20.0983 37.3232L13.3384 46.2177C11.474 48.2979 11.6695 50.9661 12.6281 52.7464C13.5669 54.4899 15.5123 56 18 56H20V64C20 70.6091 25.3909 76 32 76V84C32 86.2091 33.7909 88 36 88H64Z","stroke":"#130A09","strokeWidth":"8","strokeLinejoin":"round"}));
}

HeadOutline.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = HeadOutline;

HeadOutline.default = HeadOutline;
